import { Action, createReducer, on } from '@ngrx/store';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { User } from '../../../models/user';
import * as studyResearcherActions from '../study-researcher/study-researcher.actions';

export const studyResearcherFeatureKey = 'studyResearcher';

export const studyResearcherAdapter: EntityAdapter<User> = createEntityAdapter<User>({});

export interface StudyResearcherState extends EntityState<User> {
  loadingResearcher: boolean;
  researcherLoaded: boolean;
  selectedResearcher: User;
  newResearcher: User;
  singleResearcherVisible: boolean;
  privilegesOpened: boolean;
}

export const initialStudyResearcherState: StudyResearcherState = studyResearcherAdapter.getInitialState({
  loadingResearcher: false,
  researcherLoaded: false,
  selectedResearcher: null,
  newResearcher: null,
  singleResearcherVisible: false,
  privilegesOpened: false,
});

export const reducer = createReducer(
  initialStudyResearcherState,
  on(studyResearcherActions.getStudyResearchersSuccess, (state, { researchers }) => {
    return studyResearcherAdapter.setAll(researchers, {
      ...state,
    });
  }),
  on(studyResearcherActions.getStudyResearcherByEmailSuccess, (state, { researcher }) => {
    return {
      ...state,
      loadingResearcher: false,
      researcherLoaded: true,
      newResearcher: researcher,
      privilegesOpened: true,
    };
  }),
  on(studyResearcherActions.setSelectedStudyResearcher, (state, { selectedResearcher }) => {
    return {
      ...state,
      selectedResearcher,
      newResearcher: null,
      privilegesOpened: false,
    };
  }),
  on(studyResearcherActions.addStudyResearcherSuccess, (state, { newStudyResearcher }) => {
    return studyResearcherAdapter.addOne(newStudyResearcher, {
      ...state,
      singleResearcherVisible: true,
      selectedResearcher: null,
    });
  }),
  on(studyResearcherActions.updateStudyResearcherSuccess, (state, { updatedStudyResearcher }) => {
    return studyResearcherAdapter.updateOne(
      { id: updatedStudyResearcher.id, changes: updatedStudyResearcher },
      {
        ...state,
        singleResearcherVisible: true,
        selectedResearcher: null,
      }
    );
  }),
  on(studyResearcherActions.deleteStudyResearcherSuccess, (state, { deletedStudyResearcherId }) => {
    return studyResearcherAdapter.removeOne(deletedStudyResearcherId, {
      ...state,
    });
  }),
  on(studyResearcherActions.setPrivilegesOpened, (state, { privilegesOpened }) => {
    return {
      ...state,
      privilegesOpened,
    };
  }),
  on(studyResearcherActions.setSingleStudyResearcherPageVisibility, (state, { singleResearcherVisible }) => {
    return {
      ...state,
      singleResearcherVisible,
    };
  })
);

export function studyResearcherReducer(state: StudyResearcherState | undefined, action: Action) {
  return reducer(state, action);
}

export const { selectIds, selectEntities, selectAll, selectTotal } = studyResearcherAdapter.getSelectors();
